import React, { useState } from 'react';
import PropTypes from 'prop-types';

export default function CreateFolderInline({ onCreate }) {
    const [name, setName] = useState('');
    const [busy, setBusy] = useState(false);

    return (
        <div className="flex items-center gap-2">
            <button className="px-3 py-2 border rounded" disabled={!name || busy}
                onClick={async () => { try { setBusy(true); await onCreate(name); setName(''); } finally { setBusy(false); } }}>
                Створити 📁
            </button>
            <input className="border rounded p-2" placeholder="Назва нової папки" value={name} onChange={e => setName(e.target.value)} />
        </div>
    );
}
CreateFolderInline.propTypes = {
    onCreate: PropTypes.func.isRequired,
};

